import { z } from 'zod';

export const ProviderUserRoleColorSchemes = {
  NATIONAL_MANAGER: 'blue',
  REGIONAL_MANAGER: 'orange',
  STATE_MANAGER: 'yellow',
  SITE_MANAGER: 'green',
  CONSULTANT: 'purple',
} as const;

export const ProviderIdInputSchema = z.union([z.string(), z.number()]).transform(Number);
export type ProviderIdInputType = z.input<typeof ProviderIdInputSchema>;
export type ProviderIdInputSchemaType = z.infer<typeof ProviderIdInputSchema>;
